import React, {Component} from 'react';
import { Route, Link } from 'react-router-dom';
import Waypoint from 'react-waypoint';
import { connect } from 'react-redux';

import Layout from '../layout';
import Header from '../../shared/components/Header';
import Footer from '../../shared/components/Footer';

import Home from '../home';
import About from '../about';
import ServicesList from '../servicesList';
import ServiceDetails from '../serviceDetails';
import Contacts from '../contacts';
import Products from '../products';
import ProductsByType from '../productsByType';

import layoutStyles from '../layout/viewport.module.css';
import styles from './styles.module.css';

import {isLoadingApp} from '../../shared/state/app/selectors'
import {loadAppData} from '../../shared/state/app/actions'

class App  extends Component{ 
    state = {
        stickyHeader: false
    };

    componentDidMount = () => {
        const {dispatch} = this.props;

        dispatch(loadAppData());
    }

    isHeaderSticky = () => this.state.stickyHeader;

    handleWaypointEnter = () => this.setState(() => ({ stickyHeader: false }));

    handleWaypointLeave = () => this.setState(() => ({ stickyHeader: true }));

    render  = ( ) => (
        <Layout>
            {
                ()=> 
                    <React.Fragment>
                        <div className={layoutStyles.phone}>
                            <Header mobile={true}/>
                        </div>
                        <div className={styles.waypoint}>
                            <Waypoint
                                onEnter={this.handleWaypointEnter}
                                onLeave={this.handleWaypointLeave}>
                            </Waypoint>
                        </div>
                        <Header sticky={this.isHeaderSticky()}/>
                        <main>
                            <Route exact path="/" component={Home} />
                            <Route exact path="/servicos" component={ServicesList} />
                            <Route exact path='/servicos/:serviceId' component={ServiceDetails} />
                            <Route exact path='/quem-somos' component={About} />
                            <Route exact path='/produtos' component={Products} />
                            <Route exact path='/produtos/tipos/:typeId' component={ProductsByType} />
                            <Route exact path='/contactos' component={Contacts} />
                        </main>
                        <Footer background={false} />
                    </React.Fragment>
            
            }
        </Layout>);
};


const mapStateToProps = () => {
    return (state) => ({
        isLoadingApp: isLoadingApp(state),
    });
};

export default connect(mapStateToProps)(App);